import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@ui/tabs";
import { useCallback, useEffect, useState } from "react";
import { AccessionForm } from "./AccessionForm";
import { FastaForm } from "./FastaForm";
import { SimpleForm } from "./SimpleForm";
import type { SequenceCreateMode } from "./sequenceCreateStore";

type SequenceCreateProps = {
  initialMode: SequenceCreateMode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function SequenceCreate({
  initialMode,
  open,
  onOpenChange,
}: SequenceCreateProps) {
  const [mode, setMode] = useState<SequenceCreateMode>(initialMode);

  useEffect(() => {
    if (open) {
      setMode(initialMode);
    }
  }, [open, initialMode]);

  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (!open) {
        setMode("simple");
      }
      onOpenChange(open);
    },
    [onOpenChange],
  );

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="min-w-1/2">
        <DialogHeader>
          <DialogTitle>Create Sequence</DialogTitle>
          <DialogDescription>Create a new sequence.</DialogDescription>
        </DialogHeader>

        <Tabs
          value={mode}
          onValueChange={(v) => setMode(v as SequenceCreateMode)}
        >
          <TabsList>
            <TabsTrigger value="simple">Simple</TabsTrigger>
            <TabsTrigger value="fasta">FASTA</TabsTrigger>
            <TabsTrigger value="accession">Accession</TabsTrigger>
          </TabsList>

          <TabsContent value="simple">
            <SimpleForm onClose={() => handleOpenChange(false)} />
          </TabsContent>

          <TabsContent
            value="fasta"
            forceMount
            className="data-[state=inactive]:hidden"
          >
            <FastaForm onClose={() => handleOpenChange(false)} />
          </TabsContent>

          <TabsContent
            value="accession"
            forceMount
            className="data-[state=inactive]:hidden"
          >
            <AccessionForm onClose={() => handleOpenChange(false)} />
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
}
